<template>
  <div id="complain">
		<p class="address">
			详细位置：<span class="address" v-if="this.address">{{this.address}}</span>
		</p>
		<!--事件内容-->
		<div class="complainContent">
			<p>事件内容：</p><p  class="content">{{this.content}}</p>
		</div>
		<ul>
	 		<li :key='item.index' v-for="item in items.imgs" ><img :src="item.thumbPath"  @click="Big(item.path)"  /></li>
	 	</ul>
		<!--处理人 -->
		<div class="handler" v-if="this.status>=2">
			<p>处理人：<span>{{this.name}}</span></p>
			<p>联系电话：<span >{{this.tel}}</span></p>
			<p>接单时间：<span >{{this.startTime}}</span></p>
		</div>
		<!--处理过程以及结果   已完成的状态 显示-->
		<div class="handleProcess" v-if="this.status>=4">
			<p>
				处理过程：<span>{{this.process}}</span>
			</p>
			<p>
				处理结果：<span>{{this.result}}</span>
			</p>
		</div>
  </div>
</template>
<script>
	import wx from 'weixin-js-sdk';
export default{
  data () {
    return {
      currentSrc:'',
      currentUrl:[],
    	status:0,  //状态
    	items:{
    		imgs:[] ,     //投诉图片 缩略图
    		srcimgs:[]    //点击之后放大的原图
    	},
    	address:'',
    	content:'',
    	name:'',  //接单人
    	tel:'',  //联系电话
    	startTime:'',  //接单时间
    	process:'',  //处理过程
    	result:'',   //处理接口
    	finished:[]
    }
  },
  methods: {
    wxConfig () {
      let vm = this
      vm.postRequest('wxSign/jsSDKSign', {
        url:window.location.href
      },function (data) {
        vm.currentUrl=vm.items.srcimgs;
        wx.config({
          appId: sessionStorage.getItem('appId'), // 必填，公众号的唯一标识
          timestamp: data.timestamp , // 必填，生成签名的时间戳
          nonceStr: data.noncestr, // 必填，生成签名的随机串
          signature: data.signature, // 必填，签名，见附录1
          jsApiList: ['previewImage'] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
        });
      })
    },
    Big(value){
      let vm = this
      vm.currentSrc=value;
      console.log(vm.currentUrl)
      wx.previewImage({
        current: vm.currentSrc, // 当前显示图片的http链接
        urls: vm.currentUrl // 需要预览的图片http链接列表
      });
    }
  },
     mounted () {
       let vm = this
       vm.postRequest('/wo/detail',{
				  		id:vm.$route.params.id
		  	},function (data) {
         vm.status=data.pstateNum  //状态
         vm.address=data.address
         vm.content=data.billcontent
         vm.items.imgs=data.submitImages   //投诉图片
         // vm.name=data.repairpsns[0].psnname  //接单人
         // vm.tel=data.repairpsns[0].psnmobile  //联系电话

         if(data.repairpsns && data.repairpsns.length){
           for(let i in data.repairpsns){
             if(data.repairpsns[i].psnname == data.acceptperson){
               vm.name = data.acceptperson ;
               vm.tel = data.repairpsns[i].psnmobile ;
             }
           }
         }
         vm.startTime=data.receivedate  //接单时间
         vm.process=data.hand_method  //处理过程
         vm.result=data.hand_result //处理结果
         //点击之后的显示的图片 不是缩略图
         for(let i=0;i<data.submitImages.length;i++){
           vm.items.srcimgs.push(data.submitImages[i].path)
         }
         vm.wxConfig ()
       })
   }
}
</script>
<style scoped>
 #complain .address{
 		line-height: 88px;
 }

  #complain .complainContent{
  	/*height: 250px;*/
  	margin-top: 10px;
  	padding-top: 20px;
  	background-color: #fff;
  	/*position: relative;*/
  }
 #complain .complainContent>p{
 	line-height: 60px;
 	font-size: 32px;
 	color: #333;
 }
 /*投诉内容*/
  #complain .complainContent .content{
 	resize: none;
 	line-height: 45px;
 	padding:0 30px;
 	font-size: 26px;
 	color: #999;
 }
  #complain p{
  	font-size:32px;
  	color: #333;
  	line-height: 60px;
  	text-align: left;
  	padding-left: 30px;
  	box-sizing: border-box;
  	background-color: #fff;
  }
  #complain p span{
  	font-size: 26px;
  	color: #999;
  }
  /*投诉图片*/
 	#complain ul{  /*图片*/
			margin-bottom: 20px;
			padding: 30px 50px;
			box-sizing: border-box;
			display: flex;
			background-color: #fff;
		}
 	#complain ul li{
			float:left;
			height:120px;
		}
	#complain ul li	img{
				width:120px;
				height:120px;
				margin-right: 50px;
		}
  /*处理人*/
  #complain .handler p:first-child{
  	padding-top: 24px;
  }
  #complain .handler p:first-child span{
  	margin-left: 30px;
  }
   #complain .handler p:last-child{
  	padding-bottom: 24px;
  }
  #complain .handler,#complain .handleProcess{
  	margin-top: 17px;
  }
  #complain .handleProcess p:first-child{
  	padding-top: 24px;
  }
   #complain .handleProcess p:last-child{
  	padding-bottom: 24px;
  }
    /*处理过程以及结果*/

</style>



// WEBPACK FOOTER //
// src/components/pub-component/complain/complainDetails.vue